import { en } from './en';
import type { EnglishMessages } from './en';

export { en };
export type { EnglishMessages };

export const messages: EnglishMessages = en;
